/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Product extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Product;


// WEBPACK FOOTER //
// ./src/routes/product/index.js